import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from '../components/fontAndend/Navbers/Navbar';
import { Footer } from '../components/fontAndend/footer/Footer';
const RootLayout = () => {
  const location = useLocation();

  // Define an array of paths where you want to exclude the footer
  const excludedPaths = ['/'];

  // Check if the current path is in the excludedPaths array
  const shouldRenderFooter = !excludedPaths.includes(location.pathname);

  return (
    <>
      <Navbar />
      <Outlet />
      {shouldRenderFooter && <Footer />}
    </>
  );
};

export default RootLayout;
